// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__zEGCv","rootSuccess":"CompleteLink_rootSuccess__1BeNv","rootFailure":"CompleteLink_rootFailure__fFn9T","isDisabled":"CompleteLink_isDisabled__5e70H"};